import { z } from 'zod';

export function transformCSVToDataRecords(data: string[][]): Record<string, string[]> {
    let [headers, ...rows] = data;

    headers = headers?.map(h => h.trim());

    // Start with empty arrays for each header
    const result: Record<string, any[]> = {};
    headers?.forEach(header => {
        result[header] = [];
    });

    // Populate the arrays with values from each row
    rows?.forEach(row => {
        headers.forEach((header, index) => {
            result[header].push(row[index]);
        });
    });
    return result;
}

type ResultType = Partial<{
    varchar: boolean;
    integer: boolean;
    numeric: boolean;
    date: boolean;
    timestamptz: boolean;
    currency: boolean;
}>;

/**
 * @param strict For now we don't want to do validation for real, so if it isn't specified to run it for real then we just won't make assumptions.
 */
export function mapValidities(data: Record<string, string[]>, zodTypes: (keyof ResultType)[], strict?: boolean) {
    const results: {
        [x: string]: ResultType;
    }[] = [];

    for (const key in data) {
        const dataAtKey = data[key];

        const validities: Partial<ResultType> = {
            ...(zodTypes.includes('varchar') && { varchar: true }),
            ...(zodTypes.includes('integer') && { integer: true }),
            ...(zodTypes.includes('numeric') && { numeric: true }),
            ...(zodTypes.includes('date') && { date: true }),
            ...(zodTypes.includes('timestamptz') && { timestamptz: true }),
            ...(zodTypes.includes('currency') && { currency: true }),
        };

        // https://github.com/colinhacks/zod/discussions/3262#discussioncomment-8558793
        // Too restrictive but keep for reference
        // const currencySchema = z
        //     .union([z.string().transform(x => x.replace(/[^0-9.-]+/g, '')), z.number()])
        //     .pipe(z.coerce.number().min(0.0001));

        if (strict) {
            for (let i = 0; i < dataAtKey.length; i++) {
                if (
                    dataAtKey[i] === 'no data available' ||
                    dataAtKey[i] === '' ||
                    dataAtKey[i] === 'null' ||
                    dataAtKey[i] === '1/0/1900'
                ) {
                    continue;
                }
                if (zodTypes.includes('integer') && z.coerce.number().int().safeParse(dataAtKey[i]).error) {
                    delete validities?.integer;
                }
                if (zodTypes.includes('numeric') && z.coerce.number().safeParse(dataAtKey[i]).error) {
                    delete validities?.numeric;
                }
                if (zodTypes.includes('varchar') && z.coerce.string().safeParse(dataAtKey[i]).error) {
                    delete validities?.varchar;
                }
                if (zodTypes.includes('date') && z.coerce.date().safeParse(dataAtKey[i]).error) {
                    delete validities?.date;
                }
                if (zodTypes.includes('timestamptz') && z.iso.time().safeParse(dataAtKey[i]).error) {
                    delete validities?.timestamptz;
                }
                if (zodTypes.includes('currency') && z.coerce.string().safeParse(dataAtKey[i]).error) {
                    delete validities?.currency;
                }
            }
        }

        results.push({
            [key]: validities,
        });
    }
    return results;
}
